export default __webpack_public_path__ + "static/media/topcharacter5.dd43d4bf.jpeg";